import React, { MouseEventHandler, useState } from 'react'
import moment, { Moment } from 'moment'
import { useTranslation } from 'react-i18next'
import { Modal, Form, InputGroup, FormControl, Button } from 'react-bootstrap'
import "../../css/SMPLButton.css"
import "../../css/AgeGate.css"
import { ReactComponent as IdCard } from "../../icon/age-gate-id-card.svg"
import BobbingIcon from '../common/BobbingIcon'

interface AgeGateProps {
  show: boolean
  prompt: string
  minimumAge: number
  passAgeGate: (didPass: boolean) => void
}

function AgeGateModal({show, prompt, minimumAge, passAgeGate}: AgeGateProps) {
  const { t } = useTranslation()

  const [birthDate, setBirthDate] = useState<Moment | null>(null)
  const [isFormValid, setIsFormValid] = useState<boolean | null>(null)

  const validate = (date: string) => {
    let parsedDate = moment(date)

    if (parsedDate.isBefore(moment().subtract(500, "years"))) {
      // Don't explicitly validate yet
      return
    }

    setIsFormValid(parsedDate.isAfter(moment().subtract(115, "years")) && parsedDate.isBefore(moment()))
    setBirthDate(parsedDate)
  }

  const submit: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()

    if (!birthDate) {
      return
    }

    let now = moment()
    let dateMarker = now.subtract(minimumAge, "years")

    passAgeGate(birthDate.isBefore(dateMarker))
  }

  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Body id="ageGate">
        <BobbingIcon horizontalOffset="-120px" verticalOffset="-90px">
          <IdCard />
        </BobbingIcon>

        <h1>{prompt}</h1>
        <p>{t('ageGate.text')}</p>

        <Form className="dateGroup" validated={isFormValid ? isFormValid : false}>
          <InputGroup>
            <FormControl
              type="date"
              name="birthDate"
              aria-label="Birth date"
              max={moment().format("yyyy-MM-DD")}
              isInvalid={isFormValid === false}
              onChange={(e) => validate(e.target.value)}
              required
            />
            <InputGroup.Append>
              <Button
                type="submit"
                onClick={submit}
                disabled={!isFormValid}
              >
                {t('ageGate.submit')}
                    </Button>
            </InputGroup.Append>
          </InputGroup>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default AgeGateModal
